import styled from "styled-components";

export const StyledTabsWrapper = styled.div`
  overflow: hidden;
`;
